import { createFileRoute, Outlet } from "@tanstack/react-router"

export const Route = createFileRoute("/qr/$qrLookupID/dev")({
  component: RouteComponent,
})

function RouteComponent() {
  return <Outlet />
}
